//crete custom dropdown

function create_custom_dropdowns() {
    document.querySelectorAll('select').forEach(function(select) {
        if (!select.nextElementSibling || !select.nextElementSibling.classList.contains('dropdown-select')) {
            var dropdown = document.createElement('div');
            dropdown.classList.add('dropdown-select', 'wide');
            if (select.getAttribute('class')) {
                dropdown.classList.add(select.getAttribute('class'));
            }
            dropdown.setAttribute('tabindex', '0');
            dropdown.innerHTML = '<span class="current"></span><div class="list"><ul></ul></div>';
            select.insertAdjacentElement('afterend', dropdown);

            var options = select.querySelectorAll('option');
            var selected = select.querySelector('option:checked');
            dropdown.querySelector('.current').textContent = selected.dataset.displayText || selected.textContent;

            options.forEach(function(option) {
                var display = option.dataset.displayText || '';
                var li = document.createElement('li');
                li.classList.add('option');
                if (option.selected) {
                    li.classList.add('selected');
                }
                li.dataset.value = option.value;
                li.dataset.displayText = display;
                li.textContent = option.textContent;
                dropdown.querySelector('ul').appendChild(li);
            });
        }
    });

    document.querySelectorAll('.dropdown-select ul').forEach(function(ul) {
        var searchDiv = document.createElement('div');
        searchDiv.classList.add('dd-search');
        searchDiv.innerHTML = '<input id="txtSearchValue" autocomplete="off" onkeyup="filter()" class="dd-searchbox" type="text">';
        ul.before(searchDiv);
    });
}

// Event listeners

// Open/close
document.addEventListener('click', function(event) {
    var clickedElement = event.target;
    if (clickedElement.classList.contains('dropdown-select')) {
        if (clickedElement.classList.contains('open')) {
            clickedElement.querySelectorAll('.option').forEach(function(option) {
                option.removeAttribute('tabindex');
            });
        } else {
            clickedElement.querySelectorAll('.option')[0].setAttribute('tabindex', '0');
        }
        clickedElement.classList.toggle('open');
        if (clickedElement.classList.contains('open')) {
            clickedElement.querySelector('.selected').focus();
        } else {
            clickedElement.focus();
        }
    } else if (!clickedElement.closest('.dropdown-select')) {
        document.querySelectorAll('.dropdown-select').forEach(function(dropdown) {
            dropdown.classList.remove('open');
            dropdown.querySelectorAll('.option').forEach(function(option) {
                option.removeAttribute('tabindex');
            });
        });
    } else if (clickedElement.classList.contains('option')) {
        document.querySelectorAll('.dropdown-select').forEach(function(dropdown) {
            dropdown.classList.remove('open');
        });
    }
    event.stopPropagation();
});

function filter() {
    var valThis = document.querySelector('#txtSearchValue').value;
    document.querySelectorAll('.dropdown-select ul > li').forEach(function(li) {
        var text = li.textContent;
        if (text.toLowerCase().indexOf(valThis.toLowerCase()) > -1) {
            li.style.display = '';
        } else {
            li.style.display = 'none';
        }
    });
}

// Option click
document.addEventListener('click', function(event) {
    var clickedElement = event.target;
    if (clickedElement.classList.contains('option')) {
        var dropdown = clickedElement.closest('.dropdown-select');
        dropdown.querySelector('.selected').classList.remove('selected');
        clickedElement.classList.add('selected');
        var text = clickedElement.dataset.displayText || clickedElement.textContent;
        dropdown.querySelector('.current').textContent = text;
        dropdown.previousElementSibling.value = clickedElement.dataset.value;
        dropdown.previousElementSibling.dispatchEvent(new Event('change'));
    }
});

// Keyboard events
document.addEventListener('keydown', function(event) {
    var focusedDropdown = document.querySelector('.dropdown-select.open');
    if (!focusedDropdown) return;

    var focusedOption = focusedDropdown.querySelector('.list .option:focus') || focusedDropdown.querySelector('.list .option.selected');

    switch (event.keyCode) {
        case 13: // Enter
            event.preventDefault();
            focusedOption.click();
            break;
        case 38: // Up
            event.preventDefault();
            if (focusedOption.previousElementSibling) {
                focusedOption.previousElementSibling.focus();
            }
            break;
        case 40: // Down
            event.preventDefault();
            if (focusedOption.nextElementSibling) {
                focusedOption.nextElementSibling.focus();
            }
            break;
        case 27: // Esc
            event.preventDefault();
            focusedDropdown.classList.remove('open');
            focusedDropdown.focus();
            break;
    }
});

document.addEventListener('DOMContentLoaded', function() {
    create_custom_dropdowns();
});

document.addEventListener("DOMContentLoaded", function() {
    document.getElementById("custom-dropdown").addEventListener("change", function() {
        var selectedOption = this.options[this.selectedIndex];
        if (selectedOption.value) {
            // Smooth scroll to the selected URL
            smoothScroll(selectedOption.value);
        }
    });
});

// Function to perform smooth scrolling for mobile

function smoothScroll(target) {
    var targetElement = document.querySelector(target);
    if (targetElement) {
        window.scrollTo({
            top: targetElement.offsetTop - 60,
            behavior: 'smooth' // Smooth scrolling behavior
        });
    }
}
